import { LogoWrapper } from '@anm/components/Logo/Wrapper';
import {
  HEADER_HEIGHT_MOBILE,
  LEFTBAR_BOTTOM_PADDING,
  LEFTBAR_TOP_PADDING,
  MOBILE_NAVIGATION_DROPDOWN_HEIGHT
} from '@anm/styles/constants';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ContentWrapper, NavButton } from '../../layouts/LeftBarLayout';
import { ButtonsWrapper, LayoutButtonsWrapper, LinkButton, StickyWrapper } from '../../layouts/LeftBarLayout/Wrapper';
import { UserSubscriptionWrapper } from '../../user/UserSubscription';

export const LinkWrapper = styled.div`
  margin-left: 8px;
  margin-top: auto;
  a {
    font-weight: bold;
    color: var(--gray_500);
  }
`;

export const LeftBarNavBottomContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const tabletScrollToTopNavigationStyles = css`
  top: 71px;
  transform: translateY(0);
`;

const tabletStyles = media.tablet<{ scrollDirection: boolean; hideMobileNavigationDropdown?: boolean }>`
  flex-direction: column;
  ${ContentWrapper} {
    width: 100%;
    max-width: 100%
  }
  nav {
    max-width: 100%;
    padding: 0;
    position: sticky;
    top: 0;
    transform: translateY(-400%);
    background-color: #fff;
    ${({ scrollDirection }) => !scrollDirection && tabletScrollToTopNavigationStyles};
    ${({ hideMobileNavigationDropdown }) => hideMobileNavigationDropdown && `display: none`};
    ${StickyWrapper} {
      height: auto;
      flex-direction: row;
      max-width: 100%;
      padding: 10px 14px 0;
    }
    ${LogoWrapper}, ${LeftBarNavBottomContent} {
      display: none;
    }
    ${LayoutButtonsWrapper} {
      margin-top: 0;
      width: 100%;
      ${ButtonsWrapper} {
        &:before {
          display: none;
        }
      }
    }
  }
`;

const navOrdering = css`
  &:nth-child(1) {
    order: 0;
  }
  &:nth-child(2) {
    order: 1;
  }
  &:nth-child(3) {
    order: 4;
  }
  &:nth-child(4) {
    order: 6;
  }
`;

const SectionWrapper = styled.div<{ scrollDirection: boolean; topMargin: number }>`
  display: flex;
  && div[data-title*='Streams'] {
    height: unset;
    min-height: 75px;
    line-height: 25px;
    img {
      margin-top: 15px;
      align-self: baseline;
    }
  }
  nav {
    border: none;
    width: 100%;
    max-width: 222px;
    background-color: var(--gray_20);
    padding: ${LEFTBAR_TOP_PADDING} 16px ${LEFTBAR_BOTTOM_PADDING};
    ${LogoWrapper} {
      margin-left: 12px;
    }
    ${NavButton} {
      min-width: 170px;
      width: 100%;
      padding-left: 15px;
      ${navOrdering};
    }
    ${LinkButton} {
      ${navOrdering};
    }
    ${StickyWrapper} {
      height: 100vh;
      top: ${LEFTBAR_TOP_PADDING};
      max-height: calc(100vh - ${LEFTBAR_TOP_PADDING} - ${LEFTBAR_BOTTOM_PADDING});
      display: flex;
      flex-direction: column;
    }
    ${LayoutButtonsWrapper} {
      margin-top: ${({ topMargin }) => topMargin}px;
    }
    ${ButtonsWrapper} {
      &:before {
        content: '';
        display: block;
        width: 100%;
        max-width: 158px;
        border-bottom: 1px solid rgba(0, 56, 87, 0.2);
        margin: 10px auto 20px;
        order: 5;
      }
    }
  }
  ${UserSubscriptionWrapper} {
    padding: 27px 48px;
    margin-left: 0;
    > *:first-child {
      margin: 0;
    }
  }
  ${ContentWrapper} {
    padding: 0;
  }
  ${tabletStyles};
`;

export const VideoTemplatesWithSideMenuWrapper = styled.div`
  margin-top: -${HEADER_HEIGHT_MOBILE};
  main {
    padding-top: ${MOBILE_NAVIGATION_DROPDOWN_HEIGHT};
  }
`;

export default SectionWrapper;
